export default "__VITE_ASSET__bsGtCyhC__"